import { Card } from "antd";
import { useAuth } from "react-oidc-context";
import React, { useState } from "react";
import User from "./User";

const baseHostUrl = process.env.REACT_APP_HOST_URL;
const baseApiUrl = process.env.REACT_APP_API_URL;

export default function Patient() {
  const auth = useAuth();
  const [updatedSession, setUpdatedSession] = useState<boolean>(false);

  const roomId = localStorage.getItem("roomId");
  const tan = localStorage.getItem("tan");

  React.useEffect(() => {
    const updateSession = async () => {
      const result = await fetch(
        `${baseApiUrl}/api/ak/session?tanId=${tan}&roomId=${roomId}&value=${auth.user!
          .id_token!}`,
        {
          method: "POST",
        },
      );
      if (result.status !== 200) throw new Error("Error updating session");
      setUpdatedSession(true);
    };

    if (updatedSession || !auth?.user?.id_token) return;

    updateSession();
  }, [updatedSession, auth?.user?.id_token]);

  if (auth.isAuthenticated && !updatedSession)
    return (
      <div className="d-flex justify-content-center">
        <div
          className="spinner-border text-primary mb-3 mySpinner"
          role="status"
          id="loading"
        ></div>
      </div>
    );

  return (
    <>
      <div>
        {auth.isAuthenticated && (
          <div>
            <div style={{ marginTop: "40px" }}>
              <User />
            </div>

            {roomId && tan ? (
              <iframe
                style={{ marginTop: "40px" }}
                src={`https://azuma-demo.arztkonsultation.de/video/${roomId}?tan=${tan}`}
                height="600"
                width="1000"
                title="arztkonsultation"
                allow="camera *; microphone *"
              ></iframe>
            ) : (
              <div>Something went wrong. no RoomId / Tan found</div>
            )}

            <div>
              <a
                href="#"
                className="btn"
                onClick={() => void auth.signoutRedirect()}
              >
                Logout
              </a>
            </div>
          </div>
        )}

        {!auth.isAuthenticated && (
          <div style={{ marginTop: "50px" }}>
            <p>Please login with Gesundheits-ID to continue ...</p>
            <a
              href="#"
              className="btn"
              onClick={() =>
                void auth.signinRedirect({
                  redirect_uri: `${baseHostUrl}/patient`,
                })
              }
            >
              Login with Gesundheits-ID
            </a>
          </div>
        )}
      </div>
      <div style={{ marginTop: "50px" }}>
        <hr />
        <a href={`/?roomId=${roomId}&tan=${tan}`} className="btn">
          Home
        </a>
      </div>
    </>
  );
}
